import React from 'react';
import './WhoAreWe.css';
import studentone from '../../../assets/Gallery/aboutOne.png'
import studenttwo from '../../../assets/Gallery/aboutTwo.png'
import studentthree from '../../../assets/Gallery/aboutThree.png'

function WhoAreWe() {
    return (
        <div className='who-are-we-outer w-100 d-flex justify-content-center align-items-center'>
            <div className="who-are-we-inner d-flex justify-content-between align-items-center w-100">
                <div className="who-are-we-left w-50 d-flex">
                    <div className="first-student">
                        <img src={studentone} alt="" />
                    </div>
                    <div className="second-student">
                        <img src={studenttwo} alt="" />
                    </div>
                    <div className="third-student">
                        <img src={studentthree} alt="" />
                    </div>
                </div>
                <div className="who-are-we-right d-flex flex-column justify-content-center align-items-start w-50">
                    <h2 className="header-text text-align-left">Who Are We?</h2>
                    <p className="secondary-paragraph-text text-align-left">Founded with a vision to empower the next generation of hospitality professionals, LIMS – Hotel Management Institute of Siliguri has been a trusted name in hotel and hospitality education for over 13 years. With a strong commitment to excellence, LIMS offers industry-relevant training that blends theoretical knowledge with hands-on practical experience.
                        <br /><br />
                        Recognized for its 100% placement record in top cruise lines, luxury hotels, and international hospitality chains, LIMS takes pride in shaping students into confident, skilled, and globally employable professionals. Our courses are backed by ISO certification, expert faculty, and an industry-driven curriculum designed to meet the highest international standards.</p>
                </div>
            </div>
        </div>
    )
}

export default WhoAreWe
